/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Slot_Move_UpInputs */

const en_slot_move_up = /** @type {(inputs: Slot_Move_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move ${i?.name} up`)
};

const de_slot_move_up = /** @type {(inputs: Slot_Move_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} nach oben`)
};

/**
* | output |
* | --- |
* | "Move {name} up" |
*
* @param {Slot_Move_UpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const slot_move_up = /** @type {((inputs: Slot_Move_UpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slot_Move_UpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_slot_move_up(inputs)
	return en_slot_move_up(inputs)
});